import { Check, Clipboard, Code2, WandSparkles } from 'lucide-react';
import { useMemo, useState } from 'react';
import {
  convertPortalDataToRecord,
  formatPortalDataCode,
  parsePortalDataCode,
} from '../services/portalDataCode';
import './DataConverter.css';

function copyText(value) {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(value);
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  textarea.remove();
  return Promise.resolve();
}

export default function DataConverter({
  module,
  record,
  documentId,
  interactionLocked,
  onApply,
}) {
  const [source, setSource] = useState('');
  const [status, setStatus] = useState(null);
  const [copied, setCopied] = useState(false);
  const preview = useMemo(
    () => formatPortalDataCode(module, record, { documentId }),
    [documentId, module, record],
  );

  const convert = () => {
    if (interactionLocked) return;
    try {
      const parsed = parsePortalDataCode(source);
      const result = convertPortalDataToRecord(module, parsed, {
        currentRecord: record,
        documentId,
      });
      onApply(result.record);
      setStatus(result.warnings.length
        ? {
          type: 'warning',
          text: `${result.warnings[0]}${result.warnings.length > 1 ? ` (+${result.warnings.length - 1} more)` : ''}`,
        }
        : { type: 'success', text: 'Code successfully form ma convert thayu.' });
    } catch (error) {
      setStatus({ type: 'error', text: error.message || 'Code convert thai shakyo nahi.' });
    }
  };

  const copyPreview = async () => {
    try {
      await copyText(preview);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      setStatus({ type: 'error', text: 'Preview copy thai shakyo nahi.' });
    }
  };

  return (
    <details className="data-converter">
      <summary>
        <span className="converter-summary-icon"><Code2 size={18} /></span>
        <span>
          <strong>JSON / Portal Code Converter</strong>
          <small>Code paste kari form fill karo athva live form code copy karo.</small>
        </span>
      </summary>

      <div className="converter-grid">
        <section className="converter-pane">
          <header>
            <div>
              <strong>Code → Form</strong>
              <small>`tr(gu, hi, en)`, arrays ane nested objects supported chhe.</small>
            </div>
            <WandSparkles size={18} />
          </header>
          <textarea
            className="converter-input"
            value={source}
            disabled={interactionLocked}
            rows={15}
            spellCheck={false}
            placeholder={'{\n  id: "b7",\n  name: tr("ગુજરાતી", "हिन्दी", "English"),\n  isActive: true,\n}'}
            onChange={(event) => {
              setSource(event.target.value);
              setStatus(null);
            }}
          />
          {status ? <p className={`converter-status ${status.type}`}>{status.text}</p> : null}
          <button
            className="button primary converter-action"
            type="button"
            disabled={interactionLocked || !source.trim()}
            onClick={convert}
          >
            <WandSparkles size={17} /> Convert to form
          </button>
        </section>

        <section className="converter-pane preview-pane">
          <header>
            <div>
              <strong>Live form preview</strong>
              <small>Form ma changes karta code automatic update thase.</small>
            </div>
            <button
              className="button secondary compact"
              type="button"
              disabled={interactionLocked}
              onClick={copyPreview}
            >
              {copied ? <Check size={16} /> : <Clipboard size={16} />}
              {copied ? 'Copied' : 'Copy'}
            </button>
          </header>
          <pre className="converter-preview"><code>{preview}</code></pre>
        </section>
      </div>
    </details>
  );
}
